<template>
    <div 
      class="mt-4">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-row
              class="pa-4 pb-0 pt-0">
              <v-col
                cols="12" class="pb-1 pt-1">
                <v-card
                  flat
                  @click="$router.go(-1)"
                  style="cursor: pointer;"
                  color="#ffffff">
                  <v-card-text>
                    <div
                      class="d-flex align-center">
                      <div
                        class="d-flex align-center">
                        <v-icon
                          size="24"
                          :color="set_color">
                          mdi-backburger
                        </v-icon>
    
                        <div
                          class="fs-16 black--text ml-3"
                          style="font-weight: 600; padding-top: 1px;">
                          {{ $route.meta.title }}
                        </div>
                      </div>
    
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 6px;">
                  <v-card-text>
                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <v-row justify="center">
                          <v-col cols="12" md="8" class="py-0">
                            <v-stepper v-model="step_index" flat>
                              <v-stepper-header>
                                <v-stepper-step
                                  :complete="step_index > 1"
                                  step="1"
                                >
                                  Informasi Personal
                                </v-stepper-step>
          
                                <v-divider></v-divider>
          
                                <v-stepper-step
                                  :complete="step_index > 2"
                                  step="2"
                                >
                                  Informasi Pendidikan
                                </v-stepper-step>
          
                                <v-divider></v-divider>
          
                                <v-stepper-step :complete="step_index > 3" step="3">
                                  Informasi Pekerjaan
                                </v-stepper-step>
                              </v-stepper-header>
      
                            </v-stepper>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
  
                        <div class="pa-5">
                          <div step="1" v-if="step_index === 1">
                            <ValidationProvider 
                              name="Sekolah"
                              rules="required"  
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Sekolah
                                <span class="red--text">*</span>
                              </div>
          
                              <v-autocomplete
                                v-on:keyup.enter="save()"
          
                                solo
                                rounded
                                dense
                                :readonly="user.school_id !== undefined && user.school_id !== null"
          
                                :color="set_color"
                                placeholder="Pilih Sekolah"
                                v-on:change="form.jabatan_id = ''; form.jabatan_name = ''; fetchJabatan(); fetchKelas(); fetchMapel(); form.kelas_id = ''; form.mapel_id = '';"
                                
                                :items="school"
                                item-value="id"
                                item-text="name"
                                :item-color="set_color"
          
                                v-model="form.school_id"
                                class="mb-0"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider>

                            <ValidationProvider 
                              name="Nama Pegawai" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Nama Pegawai
                                <span class="red--text">*</span>
                              </div>
          
                              <v-text-field                            
                                
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Nama Pegawai"
          
                                
          
                                v-model="form.name"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-text-field>
                            </ValidationProvider>
    
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Nomor Identitas" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Nomor Identitas
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-text-field                                
                                    
                                    solo
                                    rounded
                                    dense
                                    type="number"
              
                                    :color="set_color"
                                    placeholder="Nomor Identitas"
              
                                    
              
                                    v-model="form.nik"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
          
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Jenis Kelamin" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Jenis Kelamin
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
                                    :items="[
                                      {
                                        text: 'Laki-Laki',
                                        value: 'Laki-Laki'
                                      },
                                      {
                                        text: 'Perempuan',
                                        value: 'Perempuan'
                                      }
                                    ]"
                                    item-value="value"
                                    item-text="text"
          
                                    :color="set_color"
                                    placeholder="Contoh. Laki-Laki"
          
                                    
          
                                    v-model="form.gender"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Tempat Lahir" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Tempat Lahir
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    placeholder="Contoh. Jakarta"
          
                                    
          
                                    v-model="form.tempat_lahir"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
          
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Tanggal Lahir" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Tanggal Lahir
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    placeholder="Tanggal Lahir"
                                    type="date"
                                    
          
                                    v-model="form.tgl_lahir_date"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Email" 
                                  rules="email" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Email
                                  </div>
          
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    placeholder="Contoh. email@xxxx.xx"
          
                                    
          
                                    v-model="form.email"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
          
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Nomor Telepon" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Nomor Telepon
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    solo
                                    rounded
                                    dense
                                    prefix="+62"
          
                                    :color="set_color"
                                    placeholder="Contoh. 85xxxxxxxx"
          
                                    v-model="form.mobile_phone_number"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
    
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Provinsi"
                                  rules="required"  
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Provinsi
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
              
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pilih Provinsi"
              
                                    
              
                                    :items="province"
                                    v-on:change="changeProvince()"
                                    item-value="id"
                                    item-text="name"
                                    :item-color="set_color"
              
                                    v-model="form.province_id"
                                    class="mb-0"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Kota / Kabupaten"
                                  rules="required"  
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Kota / Kabupaten
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
              
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pilih Kota / Kabupaten"
              
                                    
              
                                    :items="city"
                                    v-on:change="changeCity()"
                                    item-value="id"
                                    item-text="name"
                                    :item-color="set_color"
              
                                    v-model="form.city_id"
                                    class="mb-0"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Kecamatan"
                                  rules="required"  
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Kecamatan
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
              
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    v-on:change="changeSub()"
                                    placeholder="Pilih Kecamatan"
              
                                    
              
                                    :items="subdistrict"
                                    item-value="id"
                                    item-text="name"
                                    :item-color="set_color"
              
                                    v-model="form.subdistrict_id"
                                    class="mb-0"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Kelurahan"
                                  rules="required"  
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Kelurahan
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete
                                    v-on:keyup.enter="save()"
              
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pilih Kelurahan"
              
                                    :items="village"
                                    v-on:change="village.filter(item =>item.id === form.village_id).map(item => form.village_name = item.name)"
                                    item-value="id"
                                    item-text="name"
                                    :item-color="set_color"
              
                                    v-model="form.village_id"
                                    class="mb-0"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
  
                            <ValidationProvider 
                              name="Alamat" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Alamat
                                <span class="red--text">*</span>
                              </div>
          
                              <v-textarea
                                v-on:keyup.enter="save()"
                                
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Contoh. Jl. xxxxxxx"
          
                                v-model="form.address"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-textarea>
                            </ValidationProvider>
  
                            <div
                              class="mb-6">
                              <div 
                                class="body-2 mb-2">
                                Silahkan geser marker untuk menentukan koordinat lokasi dibawah ini:
                              </div>
          
                              <label>
                                <gmap-autocomplete
                                  placeholder="ketik alamat"
                                  class="style-auto-map mb-4"
                                  @place_changed="setPlace">
                                </gmap-autocomplete>
                              </label>
          
                              <gmap-map
                                :center="center"
                                :zoom="12"
                                :options="{
                                  zoomControl: true,
                                  mapTypeControl: false,
                                  scaleControl: false,
                                  streetViewControl: false,
                                  rotateControl: false,
                                  fullscreenControl: true,
                                  disableDefaultUi: false
                                }"
                                :clickable="true"
                                @click="updatePlace"
                                style="width: 100%; height: 400px;">
          
                                <gmap-marker
                                  :position="center"
                                  :draggable="true"
                                  @drag="updatePlace"
                                  @click="center=center">
                                </gmap-marker>
                              </gmap-map>

                              <v-row class="mt-3">
                                <v-col cols="12" md="6">
                                  <ValidationProvider 
                                    name="Latitude" 
                                    rules="required" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Latitude
                                      <span class="red--text">*</span>
                                    </div>
                
                                    <v-text-field
                                      solo
                                      rounded
                                      dense
                                      type="number"
                                      min="0"
                                      v-on:change="updatePlaceFromMap()"
                                      :color="set_color"
                                      placeholder="Tentukan Latitude"
                
                                      v-model="form.latitude"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <ValidationProvider 
                                    name="Longitude" 
                                    rules="required" 
                                    v-slot="{ errors }">
                                    <div class="fs-13 mb-1">
                                      
                                      Longitude
                                      <span class="red--text">*</span>
                                    </div>
                
                                    <v-text-field
                                      solo
                                      rounded
                                      dense
                                      type="number"
                                      min="0"
                                      v-on:change="updatePlaceFromMap()"
                                      :color="set_color"
                                      placeholder="Tentukan Longitude"
                
                                      v-model="form.longitude"
                                      :error-messages="errors"
                                      required
                                      style="border-radius: 10px;"
                                      class="mb-0">
                                    </v-text-field>
                                  </ValidationProvider>
                                </v-col>
                              </v-row>
                            </div>

                            <v-card 
                              flat
                              class="mb-5 mt-2">
                              <v-card-text class="px-1 py-0">
                                <div cclass="fs-13">
                                  Upload Foto Pegawai
                                </div>
                                <v-row>
                                  <v-col class="pb-0" cols="3" style="width: 200px;">
                                    <uploadfolder
                                      v-model="upload.image" 
                                      style="height: 200px; width: 100%">
                                      <div 
                                        slot="activator"
                                        class="cursor-pointer">
                                        <v-card 
                                          flat
                                          height="200"
                                          class="d-flex align-center justify-center"
                                          style="border-radius: 15px;
                                                border: 2px solid #eaeaea; 
                                                border-style: dashed;">
                                          <div v-if="form.image_url.length < 1">
                                            <v-icon v-if="!process.image"
                                              size="40" 
                                              color="#868b93">
                                              mdi-plus-circle-outline
                                            </v-icon>
                    
                                            <v-progress-circular v-else
                                              indeterminate
                                              :color="set_color">
                                            </v-progress-circular>
                                          </div>
                    
                                          <v-img v-else
                                            contain
                                            height="200"
                                            :src="form.image_url" 
                                            :alt="form.image_url"
                                            class="text-center d-flex align-center">
                                            <div 
                                              class="d-flex aling-center justify-center" 
                                              style="width: 100%; height: auto;">
                                              <v-icon v-if="!process.image"
                                                size="40" 
                                                color="white">
                                                mdi-plus-circle-outline
                                              </v-icon>
                    
                                              <v-progress-circular v-else
                                                indeterminate
                                                :color="set_color">
                                              </v-progress-circular>
                                            </div>
                                          </v-img>
                                        </v-card>
                                      </div>
                                    </uploadfolder>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>

                            <v-card 
                              flat
                              class="mb-5">
                              <v-card-text class="px-1 py-0">
                                <div cclass="fs-13">
                                  Upload Foto KTP
                                </div>
                                <v-row>
                                  <v-col class="pb-0" cols="4">
                                    <uploadfolder
                                      v-model="upload.ktp_url" 
                                      style="height: 200px; width: 100%">
                                      <div 
                                        slot="activator"
                                        class="cursor-pointer">
                                        <v-card 
                                          flat
                                          height="200"
                                          class="d-flex align-center justify-center"
                                          style="border-radius: 15px;
                                                border: 2px solid #eaeaea; 
                                                border-style: dashed;">
                                          <div v-if="form.ktp_url.length < 1">
                                            <v-icon v-if="!process.ktp_url"
                                              size="40" 
                                              color="#868b93">
                                              mdi-plus-circle-outline
                                            </v-icon>
                    
                                            <v-progress-circular v-else
                                              indeterminate
                                              :color="set_color">
                                            </v-progress-circular>
                                          </div>
                    
                                          <v-img v-else
                                            contain
                                            height="200"
                                            :src="form.ktp_url" 
                                            :alt="form.ktp_url"
                                            class="text-center d-flex align-center">
                                            <div 
                                              class="d-flex aling-center justify-center" 
                                              style="width: 100%; height: auto;">
                                              <v-icon v-if="!process.ktp_url"
                                                size="40" 
                                                color="white">
                                                mdi-plus-circle-outline
                                              </v-icon>
                    
                                              <v-progress-circular v-else
                                                indeterminate
                                                :color="set_color">
                                              </v-progress-circular>
                                            </div>
                                          </v-img>
                                        </v-card>
                                      </div>
                                    </uploadfolder>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>

                          </div>
    
                          <div step="2" v-if="step_index === 2">
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Jenjang Pendidikan" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Jenjang Pendidikan
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete                                
                                    
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Jenjang Pendidikan"
                                    :items="[
                                      'SD / MI',
                                      'SMP / MTs',
                                      'SMA / SMK',
                                      'Diploma 1 (D1)',
                                      'Diploma 2 (D2)',
                                      'Diploma 3 (D3)',
                                      'Diploma 4 (D4)',
                                      'Sarjana (S1)',
                                      'Magister (S2)',
                                      'Doktor (S3)'
                                    ]"
              
                                    v-model="form.education"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
  
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Nama Jurusan" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Nama Jurusan
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field                                
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    placeholder="Nama Jurusan"
          
                                    v-model="form.education_jurusan"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Nama Instansi" 
                                  rules="" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Nama Instansi
                                  </div>
          
                                  <v-text-field                                
                                    
                                    solo
                                    rounded
                                    dense
          
                                    :color="set_color"
                                    placeholder="Nama Instansi"
          
                                    v-model="form.education_instansi"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="tanggal Mulai Pendidikan" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    tanggal Mulai Pendidikan
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field                                
                                    
                                    solo
                                    rounded
                                    dense
                                    type="date"
                                    :color="set_color"
                                    placeholder="tanggal Mulai Pendidikan"
          
                                    v-model="form.education_start_date"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="tanggal Selesai Pendidikan" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    tanggal Selesai Pendidikan
                                    <span class="red--text">*</span>
                                  </div>
          
                                  <v-text-field                                
                                    
                                    solo
                                    rounded
                                    dense
                                    type="date"
                                    :color="set_color"
                                    placeholder="tanggal Selesai Pendidikan"
          
                                    v-model="form.education_end_date"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Nilai Akhir" 
                                  rules="" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Nilai Akhir
                                  </div>
          
                                  <v-text-field                                
                                    
                                    solo
                                    rounded
                                    dense

                                    type="number"
                                    min="0"
                                    :color="set_color"
                                    placeholder="Nilai Akhir"
          
                                    v-model="form.education_nilai_akhir"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <div>
                              <div class="fs-13 mb-1">
                                
                                Lampiran
                              </div>
          
                              <v-row>
                                <v-col
                                  cols="12" v-if="form.education_lampiran_url === '' || form.education_lampiran_url === null">
                                  <uploadfile
                                    v-model="upload.document" >
                                    <div 
                                      slot="activator"
                                      class="cursor-pointer">
                                      <v-card
                                        flat
                                        class="cursor-pointer"
                                        style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                                        <v-card-text
                                          class="py-2">
                                          <div v-if="!process.document"
                                            class="d-flex align-center justify-center">
                                            <v-icon 
                                              size="28" 
                                              color="#b6b6b6">
                                              mdi-cloud-upload-outline
                                            </v-icon>

                                            <div
                                              class="black--text ml-2"
                                              style="opacity: 40%; font-weight: 500;">
                                              Upload File
                                            </div>
                                          </div>

                                          <div v-if="process.document"
                                            class="text-center">
                                            <v-progress-circular
                                              indeterminate
                                              size="28"
                                              color="#b6b6b6">
                                            </v-progress-circular>
                                          </div>
                                        </v-card-text>
                                      </v-card>
                                    </div>
                                  </uploadfile>
                                </v-col>
                                <v-col cols="12" v-if="form.education_lampiran_url !== '' && form.education_lampiran_url !== null">
                                  <v-card
                                    flat
                                    style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                                    <v-icon
                                      @click="form.education_lampiran_url = ''"
                                      color="red"
                                      class="cursor-pointer"
                                      style="position: absolute; top: -10px; right: -10px;">
                                      mdi-close-circle
                                    </v-icon>

                                    <v-card-text
                                      class="py-3 line-text-second">
                                      <div
                                        class="d-flex align-center">
                                        <div style="width: 50px;">File</div> : <a :href="form.education_lampiran_url" target="_blank" class="ml-1">{{ form.education_lampiran_url }}</a>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                          <div step="4" v-if="step_index === 3">
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Nomor Kepegawaian" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Nomor Kepegawaian
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-text-field                                
                                    
                                    solo
                                    rounded
                                    dense
                                    type="number"
              
                                    :color="set_color"
                                    placeholder="Nomor Kepegawaian"
              
                                    
              
                                    v-model="form.nip"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <ValidationProvider 
                                  name="Status Kepegawaian " 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Status Kepegawaian 
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete                                
                                    
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Status Kepegawaian "
              
                                    :items="[
                                      {
                                        id: 'pns',
                                        name: 'PNS'
                                      },
                                      {
                                        id: 'pppk',
                                        name: 'PPPK'
                                      },
                                      {
                                        id: 'honorer',
                                        name: 'Honorer'
                                      },
                                      {
                                        id: 'tenaga harian lepas',
                                        name: 'Tenaga Harian Lepas'
                                      },
                                      {
                                        id: 'pegawai magang',
                                        name: 'Pegawai Magang'
                                      },
                                      {
                                        id: 'relawan',
                                        name: 'Relawan'
                                      },
                                      {
                                        id: 'relawan',
                                        name: 'Relawan'
                                      },
                                      {
                                        id: 'outsourcing',
                                        name: 'Outsourcing'
                                      }
                                    ]"
                                    item-text="name"
                                    item-value="id"
              
                                    v-model="form.status"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0" v-if="form.status === 'pns' || form.status === 'pppk'">
                                <ValidationProvider 
                                  name="Pangkat / Golongan" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <div class="fs-13 mb-1">
                                    
                                    Pangkat / Golongan
                                    <span class="red--text">*</span>
                                  </div>
              
                                  <v-autocomplete                                
                                    
                                    solo
                                    rounded
                                    dense
              
                                    :color="set_color"
                                    placeholder="Pangkat / Golongan"
              
                                    :items="[
                                      'Juru Muda (I/a)',
                                      'Juru Muda Tingkat I (I/b)',
                                      'Juru (I/c)',
                                      'Juru Tingkat I (I/d)',
                                      'Pengatur Muda (II/a)',
                                      'Penganjur Muda Tingkat I (II/b)',
                                      'Pengatur (II/c)',
                                      'Pengatur Tingkat I (II/d)',
                                      'Penata Muda (III/a)',
                                      'Penata Muda Tingkat I (III/b)',
                                      'Penant (III/c)',
                                      'Penata Tingkat I (III/d)',
                                      'Pembina Muda (IV/a)',
                                      'Pembina Muda Tingkat I (IV/b)',
                                      'Pembina (IV/c)',
                                      'Pembina Tingkat I (IV/d)',
                                      'Pembina Utama (IV/e)'
                                    ]"
                                    item-text="name"
                                    item-value="id"
              
                                    v-model="form.golongan"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    class="mb-0">
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <ValidationProvider 
                              name="Jabatan"
                              rules="required"  
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Jabatan
                                <span class="red--text">*</span>
                              </div>
          
                              <v-autocomplete
                                v-on:keyup.enter="save()"
          
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Pilih Jabatan"
          
                                v-on:change="jabatan.filter(item => item.id === form.jabatan_id).map(item => form.jabatan_name = item.name); jabatan.filter(item => item.id === form.jabatan_id).map(item => category_jabatan = item.category)"
          
                                :items="jabatan"
                                item-value="id"
                                item-text="name"
                                :item-color="set_color"
          
                                v-model="form.jabatan_id"
                                class="mb-0"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider>
                            <ValidationProvider 
                              name="Jabatan Terhitung Mulai Tanggal" 
                              rules="required" 
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Jabatan Terhitung Mulai Tanggal
                                <span class="red--text">*</span>
                              </div>
      
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                solo
                                rounded
                                dense
      
                                :color="set_color"
                                placeholder="Jabatan Terhitung Mulai Tanggal"
                                type="date"
                                
      
                                v-model="form.jabatan_tmt"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;"
                                class="mb-0">
                              </v-text-field>
                            </ValidationProvider>

                            <!-- <div v-if="category_jabatan === 'Tenaga Pendidik (Guru / Pengajar)'">
                              <ValidationProvider 
                                name="Kelas" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Kelas
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
            
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Pilih Kelas"
        
                                  multiple
                                  :items="kelas"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
            
                                  v-model="form.kelas_id"
                                  class="mb-0"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>

                              <ValidationProvider 
                                name="Mata Pelajaran" 
                                rules="" 
                                v-slot="{ errors }">
                                <div class="fs-13 mb-1">
                                  
                                  Mata Pelajaran
                                </div>
            
                                <v-autocomplete
                                  v-on:keyup.enter="save()"
            
                                  solo
                                  rounded
                                  dense
            
                                  :color="set_color"
                                  placeholder="Pilih Mata Pelajaran"
                                  multiple
            
                                  :items="mapel"
                                  item-value="id"
                                  item-text="name"
                                  :item-color="set_color"
            
                                  v-model="form.mapel_id"
                                  class="mb-0"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-autocomplete>
                              </ValidationProvider>
                            </div> -->

                            <!-- <ValidationProvider 
                              name="Hak Akses"
                              rules=""  
                              v-slot="{ errors }">
                              <div class="fs-13 mb-1">
                                
                                Hak Akses
                              </div>
          
                              <v-autocomplete
                                v-on:keyup.enter="save()"
          
                                solo
                                rounded
                                dense
          
                                :color="set_color"
                                placeholder="Pilih Hak Akses"
          
                                
          
                                :items="category"
                                item-value="id"
                                item-text="category_name"
                                :item-color="set_color"
          
                                v-model="form.category_id"
                                class="mb-0"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-autocomplete>
                            </ValidationProvider> -->



                            <div class="mb-0 font_weight_600 fs-14 black_one mb-2">
                              Dokumen Lampiran
                            </div> 
                            <div class="mb-0 font_weight_600 fs-14 black_one d-flex align-center mb-3">
                              <div class="mr-3">
                                <uploadfolder
                                  v-model="upload.image_lampiran" >
                                  <div 
                                    slot="activator"
                                    class="cursor-pointer">
                                    <v-btn
                                      color="#4B4B4B"
                                      elevation="0"
                                      small
                                      :disabled="process.image_lampiran"
                                      :loading="process.image_lampiran"
                                      min-height="30"
                                      class="fs-12 white--text text-capitalize d-flex align-center"
                                      style="border-radius: 6px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                                      <v-icon size="15">mdi-cloud-upload-outline</v-icon>
                                      
                                      <span
                                        class="ml-2 ">
                                        Tambah Gambar
                                      </span>
                                    </v-btn>
                                  </div>
                                </uploadfolder>
                              </div>
                              <div class="mr-3">
                                <uploaddoc
                                  v-model="upload.lampiran" >
                                  <div 
                                    slot="activator"
                                    class="cursor-pointer">
                                    <v-btn
                                      color="primary"
                                      elevation="0"
                                      small
                                      :disabled="process.lampiran"
                                      :loading="process.lampiran"
                                      min-height="30"
                                      class="fs-12 white--text text-capitalize d-flex align-center"
                                      style="border-radius: 6px; font-weight: 600;">
                                      <v-icon size="15">mdi-file-document</v-icon>
                                      
                                      <span
                                        class="ml-2 ">
                                        Tambah File
                                      </span>
                                    </v-btn>
                                  </div>
                                </uploaddoc>
                              </div>
                            </div>

                            <div class="">
                              <table style="border: 1px solid #ededed; width: 100%; border-collapse: collapse;">
                                <tr>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Aksi
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    Link
                                  </th>
                                  <th style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    Nama Dokumen
                                  </th>
                                </tr>
                                <tr v-for="(item, index) in form.lampiran_json" :key="index">
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="form.lampiran_json.splice(index, 1)"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          color="red"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">mdi-trash-can-outline</v-icon>
                                        </v-btn>
                                      </template>

                                      <span>Hapus</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: center; width: 60px; min-width: 60px; max-width: 60px;" class="black--text">
                                    <v-tooltip 
                                      top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          :href="item.url"
                                          target="_blank"
                                          
                                          v-bind="attrs"
                                          v-on="on"
                                          
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          :color="item.type === 'image' ? 'indigo' : item.type === 'pdf' ? '#b40c1d' : item.type === 'doc' || item.type === 'docx' ? '#1b58b8' : '#097640'"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1 px-0"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">{{ item.type === 'image' ? 'mdi-image-area' : item.type === 'pdf' ? 'mdi-file-pdf' : item.type === 'doc' || item.type === 'docx' ? 'mdi-file-word' : 'mdi-file-excel' }}</v-icon>
                                        </v-btn>
                                      </template>

                                      <span>Lihat</span>
                                    </v-tooltip>
                                  </td>
                                  <td style="font-size: 12px; z-index: 1; border: 1px solid #ededed; color: white; border-left: none; padding: 8px 12px; text-align: left; width: 100%;" class="black--text">
                                    <ValidationProvider 
                                      :name="`Nama Dokumen ${index + 1}`" 
                                      rules="required" 
                                      v-slot="{ errors, valid }">
                  
                                      <v-text-field
                                        v-on:keydown.enter.prevent="save()"
                                        
                                        filled
                                        rounded
                                        dense
                  
                                        :color="set_color"
                                        placeholder="Nama Dokumen"
                  
                                        v-model="item.title"
                                        :success="item.title !== '' && valid"
                                        :error-messages="errors"
                                        required
                                        class="mb-0"
                                        style="border-radius: 10px;">
                                      </v-text-field>
                                    </ValidationProvider>
                                  </td>
                                </tr>
                              </table>

                              <v-card-text
                                v-if="form.lampiran_json.length === 0"
                                class="pb-0 mb-4" style="height: 200px; display: flex; align-items: center; justify-content: center; border: 1px solid #eee; border-top: none;">
                                <div class="text-center">
                                  <div class="mt-3 fs-16">
                                    Belum ada data
                                  </div>
                                </div>
                              </v-card-text>
                            </div>
                          </div>
                        </div>
                      </v-form>
                    </ValidationObserver>
                    <div v-if="message.error.length > 0"
                      class="text-left mt-0">
                      <div
                        class="error--text d-flex align-start">
                        <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                  <v-card-actions class="pa-5">
                    <v-btn
                      @click="step_index = step_index - 1"
                      :disabled="process.form"
                      elevation="0"
                      :color="set_color"
                      dark
                      v-if="step_index > 1"
                      rounded
                      class="white--text text-capitalize"
                      style="border-radius: 6px;">
                      Sebelumnya
                    </v-btn>
                    <v-spacer/>
                    <v-btn
                      @click="toNextStep()"
                      :disabled="process.form"
                      elevation="0"
                      :color="set_color"
                      dark
                      v-if="step_index < 3"
                      rounded
                      class="white--text text-capitalize"
                      style="border-radius: 6px;">
                      Selanjutnya
                    </v-btn>
  
                    <v-btn
                      @click="save()"
                      :disabled="process.form"
                      dark
                      v-if="step_index === 3"
                      elevation="0"
                      :color="set_color"
                      class="white--text text-capitalize"
                      style="border-radius: 6px;">
                      Simpan
                    </v-btn>
  
                    <v-btn
                      to="/manajemen-akademik/data-pengguna/data-guru-pegawai"
                      :disabled="process.form"
                      width="85"
                      outlined
                      elevation="0"
                      color="red"
                      style="border-radius: 6px;"
                      class="fs-13 font-weight-bold text-capitalize white--text">
                      Batal
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import axios from "axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          filter: {
            school_id: '',
          },
          step_index: 1,
          form: {
            id: '',
            school_id: '',
            category_id: '',
            nip: '',
            name: '',
            email: '',
            gender: '',
            tempat_lahir: '',
            tgl_lahir_date: '',
            jabatan_id: '',
            jabatan_name: '',
            golongan: '',
            image_url:'',
            mobile_phone_number: '',
            jabatan_tmt: '',

            nik: '',
            province_id: '',
            city_id: '',
            subdistrict_id: '',
            province_name: '',
            city_name: '',
            subdistrict_name: '',
            village_id:'',
            village_name: '',
            address: '',
            latitude: '',
            longitude: '',
            ktp_url: '',
            education: '',
            education_jurusan: '',
            education_instansi: '',
            education_start_date: '',
            education_end_date: '',
            education_nilai_akhir: '',
            education_lampiran_url: '',
            status: '',
            kelas_id: [],
            mapel_id: [],
            lampiran_json: []
          },
          center: {
            lat: -7.703889, 
            lng: 110.60166
          },

          category_jabatan: '',
          
          upload: {
            image: '',
            ktp_url: null,
            galery_array: null,
            document: '',
            image_lampiran: null,
            lampiran: null
          },
          province: [],
          city: [],
          subdistrict: [],
          school: [],
          village: [],
          kurikulum: [],
          jabatan: [],
          category: [],
          mapel: [],
          kelas: [],
  
          process: {
            load: false,
            image: false,
            form: false,
            ktp_url: false,
            galery_array: false,
            document: false,
            image_lampiran: false,
            lampiran: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue'),
        uploadfile: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/document_pdf.vue'),
        uploaddoc: () => import(/* webpackPrefetch: true */ '@/components/upload/document.vue'),
      },
      watch: {
        'upload.image_lampiran': {
        handler: function () {
          if (this.upload.image_lampiran) {
            // this.form.request_file_object.type = 'image'
            this.message.error = ''
            this.process.image_lampiran = this.upload.image_lampiran.process

            if (!this.process.image_lampiran) {
              this.form.lampiran_json.push({
                title: '',
                url: this.upload.image_lampiran.fileuri,
                type: 'image'
              })

              this.upload.image_lampiran = null

              // this.form.request_file_object.url = this.upload.image.fileuri
            }
          }
        },
        deep: true
      },
      'upload.document': {
        handler: function () {
          if (this.upload.lampiran) {
            // this.form.request_file_object.type = 'file'
            this.message.error = ''
            this.process.lampiran = this.upload.lampiran.process
            
            if (!this.process.lampiran) {
              var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
              var extension = this.upload.lampiran.fileuri.match(regexp);
              // CALLBACK FROM UPLOAD IMAGE
              this.form.lampiran_json.push({
                title: '',
                url: this.upload.lampiran.fileuri,
                type: extension && extension[1]
              })

              this.upload.lampiran = null

              // this.form.request_file_object.url = this.upload.document.fileuri
            }
          }
        },
        deep: true
      },
        'upload.image': {
          handler: function () {
            if (this.upload.image) {
              this.process.image = this.upload.image.process
  
              if (!this.process.image) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.ktp_url': {
          handler: function () {
            if (this.upload.ktp_url) {
              this.process.ktp_url = this.upload.ktp_url.process
  
              if (!this.process.ktp_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.ktp_url = this.upload.ktp_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        },
        'upload.galery_array': {
          handler: function () {
            if (this.upload.galery_array) {
              this.process.galery_array = this.upload.galery_array.process
  
              if (!this.process.galery_array) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.galery_array.push({
                  galery_url: this.upload.galery_array.fileuri,
                  galery_desc: ''
                })
  
                // this.save_image()
  
                this.upload.galery_array = null
              }
            }
          },
          deep: true
        },
        'upload.document': {
          handler: function () {
            if (this.upload.document) {
              // this.f.rab_file_object.type = 'file'
              this.message.error = ''
              this.process.document = this.upload.document.process
              
              if (!this.process.document) {
                var regexp = /\.([0-9a-z]+)(?:[\?#]|$)/i;
                var extension = this.upload.document.fileuri.match(regexp);
                this.form.education_lampiran_url = this.upload.document.fileuri

                this.upload.document = null

                // this.f.rab_file_object.url = this.upload.document.fileuri
              }
            }
          },
          deep: true
        },
        '$store.state.school': function(val) {
          this.form.school_id = val
        },
        // 'options': {
        //   handler () {
        //     let pagination = { row: this.limit, page: 1 }
            
        //     this.fetch(pagination)
        //   },
        //   deep: true
        // }
      },
      computed: {
        token () {
          return this.$store.state.token
        },
        user () {
        this.form.school_id = this.$store.state.user.school_id === undefined || this.$store.state.user.school_id === null ? this.$store.state.school !== undefined && this.$store.state.school !== null && this.$store.state.school !== '' ? this.$store.state.school : '' : this.$store.state.user.school_id
          return this.$store.state.user
        },
        set_color () {
          return this.$store.state.color
        }
      },
      mounted () {
        this.fetchProv()
        this.fetchSchool()
        this.fetchCategory()
        this.fetchJabatan()
        this.fetchKelas()
        this.fetchMapel()
      },
      methods: {
        async fetchSchool() {

          let params = {
          limit: 10000000000000
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/school/data' : 'school/data'
        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.school = res.results.data
          }
        })
      },
      async fetchCategory() {

         let params = {
          limit: 10000000000000,
          school_id: this.filter.school_id
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/category/data' : 'pegawai_category/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.category = res.results.data
          }
        })
      },

      async fetchJabatan() {

         let params = {
          limit: 10000000000000,
          school_id: this.form.school_id
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/jabatan/data' : 'jabatan/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.jabatan = res.results.data
          }
        })
      },

      async fetchKelas() {

         let params = {
          limit: 10000000000000,
          school_id: this.form.school_id
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/kelas/data' : 'kelas/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.kelas = res.results.data
          }
        })
      },

      async fetchMapel() {

         let params = {
          limit: 10000000000000,
          school_id: this.form.school_id
        }

        let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? 'pegawai/mapel/data' : 'mapel/data'

        await get(`${url}`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.mapel = res.results.data
          }
        })
      },
        async fetchProv() {
  
           let params = {
            limit: 10000000000000
          }
  
  
          await get(`ref/provinsi`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.province = res.results.data
            }
          })
        },
  
        changeProvince() {
          this.form.city_id = ''
          this.form.city_name = ''
          this.form.subdistrict_id = ''
          this.form.subdistrict_name = ''
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.province.map(obj => {
            if (obj.id === this.form.province_id) {
              id = obj.id
              this.form.province_name = obj.name
            }
          })
          this.fetchCity(id)
        },
  
        async fetchCity(id) {
  
           let params = {
            limit: 10000000000000,
            province_id: id
          }
  
          await get(`ref/kota`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.city = res.results.data
            }
          })
        },
  
        changeCity() {
          this.form.subdistrict_id = ''
          this.form.subdistrict_name = ''
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.city.map(obj => {
            if (obj.id === this.form.city_id) {
              id = obj.id
              this.form.city_name = obj.name
            }
          })
          this.fetchSub(id)
        },
  
        async fetchSub(id) {
  
           let params = {
            limit: 10000000000000,
            city_id: id
          }
  
          await get(`ref/kecamatan`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.subdistrict = res.results.data
            }
          })
        },
  
        changeSub() {
          this.form.village_id = ''
          this.form.village_name = ''
          let id = ''
          this.subdistrict.map(obj => {
            if (obj.id === this.form.subdistrict_id) {
              id = obj.id
              this.form.subdistrict_name = obj.name
            }
          })
          this.fetchVillage(id)
        },
  
        async fetchVillage(id) {
  
           let params = {
            limit: 10000000000000,
            subdistrict_id: id
          }
  
          await get(`ref/kelurahan`, { params })
          .then(response => {
            let res = response.data
            
            if (res.status === 200) {
              this.village = res.results.data
            }
          })
        },
  
        setPlace(place) {
          this.place = place
          this.center = {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng(),
          
          }
            // this.initMap()
          this.form.latitude = this.place.geometry.location.lat()
          this.form.longitude = this.place.geometry.location.lng()
        },
        getGeoLocation() {
          if (this.form.id === '') {
            navigator.geolocation.getCurrentPosition(position => {
              this.center = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
            })
          } else {
            this.center = {
              lat: this.form.latitude,
              lng: this.form.longitude
            }
          }
        },
        updatePlace(location) {
          this.center = {
            lat: location.latLng.lat(),
            lng: location.latLng.lng()
          }
  
          this.form.latitude = location.latLng.lat()
          this.form.longitude = location.latLng.lng()
        },

        updatePlaceFromMap() {
          this.center = {
            lat: this.form.latitude*1,
            lng: this.form.longitude*1
          }
        },
  
        async toNextStep  () {
          this.message.error = ''
          this.$refs.form.validate().then(success => {
            if (success) {
              this.step_index = this.step_index + 1
            if (this.$refs.form) this.$refs.form.reset()
            }
          })
        },
  
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
  
          if (isValid) {
            this.process.form = true

            let form = {
              ...this.form,
              lampiran_json: JSON.stringify(this.form.lampiran_json),
              mobile_phone_number: `62${this.form.mobile_phone_number}`
            }
  
            let url = this.$store.state.user.school_id !== undefined && this.$store.state.user.school_id !== null ? this.form.id === '' ? 'pegawai/master/add' : 'pegawai/master/update' : this.form.id === '' ? 'pegawai/add' : 'pegawai/update'
  
            // SAVE TO REST API
            await post(url, {
              // data: {
              //   id: this.form.id,
              //   school_id: this.filter.school_id,
              //   category_id: this.form.category_id,
              //   nip: this.form.nip,
              //   name: this.form.name,
              //   email: this.form.email,
              //   gender: this.gender,
              //   tempat_lahir: this.form.tempat_lahir,
              //   tgl_lahir_date: this.form.tgl_lahir_date,
              //   jabatan_id: this.form.jabatan_id,
              //   jabatan_name: this.form.jabatan_name,
              //   golongan: this.form.golongan,
              //   image_url: this.form.image_url,
              //   mobile_phone_number: this.form.mobile_phone_number,
              //   jabatan_tmt: this.form.jabatan_tmt,

              //   nik: this.form.nik,
              //   province_id: this.form.province_id,
              //   city_id: this.form.city_id,
              //   subdistrict_id: this.form.subdistrict_id,
              //   province_name: this.form.province_name,
              //   city_name: this.form.city_name,
              //   subdistrict_name: this.form.subdistrict_name,
              //   village_id: this.form.village_id,
              //   village_name: this.form.village_name,
              //   address: this.form.address,
              //   latitude: this.form.latitude,
              //   longitude: this.form.longitude,
              //   ktp_url: this.form.ktp_url,
              //   education: this.form.education,
              //   education_jurusan: this.form.education_jurusan,
              //   education_instansi: this.form.education_instansi,
              //   waktu_tempuh: this.form.waktu_tempuh,
              //   education_nilai_akhir: this.form.education_nilai_akhir,
              //   education_lampiran_url: this.form.education_lampiran_url,
              //   status: this.form.status,
              //   kelas_id: this.form.kelas_id,
              //   mapel_id: this.form.mapel_id,
              //   lampiran: this.form.lampiran
                
              // }
              data: form
            })
            .then(response => {
              let res = response.data
              
              this.process.form = false
  
              if (res.status === 200) {
  
                this.$router.push({ path: '/manajemen-akademik/data-pengguna/data-guru-pegawai' })
  
              } else {
                this.message.error = res.message
              }
            })
  
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        },
      },
      created () {
      }
    }
  </script>